import { Box } from '@primer/react';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { ReactNode } from 'react';
import styled from 'styled-components';

/**
 * Renders the bottom and side axes of double materiality matrix.
 */

export function Axes() {
  return (
    <>
      <>
        {/* Y-axis, on the left side of the matrix */}
        <VerticalContainer
          style={{
            gridColumn: 'y-label',
            gridRow: 'y-high / span 3',
            fontWeight: 'bold',
          }}
        >
          <span>Impact materiality →</span>
        </VerticalContainer>
        <BucketLabelWithTick gridColumn="y-bucket-labels" gridRow="y-high" direction="vertical">
          High
        </BucketLabelWithTick>

        <BucketLabelWithTick gridColumn="y-bucket-labels" gridRow="y-medium" direction="vertical">
          Medium
        </BucketLabelWithTick>

        <BucketLabelWithTick gridColumn="y-bucket-labels" gridRow="y-low" direction="vertical">
          Low
        </BucketLabelWithTick>
      </>
      <>
        {/* X-axis, below the matrix */}
        <BucketLabelWithTick gridColumn="x-low" gridRow="x-bucket-labels" direction="horizontal">
          Low
        </BucketLabelWithTick>
        <BucketLabelWithTick gridColumn="x-medium" gridRow="x-bucket-labels" direction="horizontal">
          Medium
        </BucketLabelWithTick>
        <BucketLabelWithTick gridColumn="x-high" gridRow="x-bucket-labels" direction="horizontal">
          High
        </BucketLabelWithTick>
        <HorizontalContainer style={{ gridColumn: 'x-low / span 3', gridRow: 'x-label', fontWeight: 'bold' }}>
          Financial materiality →
        </HorizontalContainer>
      </>
    </>
  );
}

const BucketLabelWithTick = (props: {
  children: ReactNode;
  gridColumn: string;
  gridRow: string;
  direction: 'horizontal' | 'vertical';
}) => {
  const Container = props.direction === 'horizontal' ? HorizontalContainer : VerticalContainer;
  const Tick = props.direction === 'horizontal' ? HorizontalTick : VerticalTick;
  return (
    <>
      <Container sx={{ gridColumn: props.gridColumn, gridRow: props.gridRow, color: 'fg.muted' }}>
        {props.children}
      </Container>
      <Tick gridColumn={props.gridColumn} gridRow={props.gridRow} />
    </>
  );
};

const HorizontalContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
`;

const VerticalContainer = styled(HorizontalContainer)`
  writing-mode: vertical-rl;
  transform: rotate(-180deg);
`;

const HorizontalTick = (props: { gridColumn: string; gridRow: string }) => {
  return (
    <div
      style={{
        gridColumn: props.gridColumn,
        gridRow: props.gridRow,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
      }}
    >
      <div style={{ backgroundColor: BouColor.TOOL_BORDER_LIGHTER_GRAY, width: '1px', height: '9px' }} />
    </div>
  );
};

const VerticalTick = (props: { gridColumn: string; gridRow: string }) => {
  return (
    <div
      style={{
        gridColumn: props.gridColumn,
        gridRow: props.gridRow,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'center',
      }}
    >
      <div style={{ backgroundColor: BouColor.TOOL_BORDER_LIGHTER_GRAY, width: '9px', height: '1px' }} />
    </div>
  );
};
